module.exports = __webpack_public_path__ + "media/assets/og-image-ca7a0275bac4f1aa15b88c8d8066959e.jpg";